var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 8.5,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 8.5,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 8.5,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 16,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 23.5,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 31,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5,
    y: 31,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 31,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 23.5,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 16,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 8.5,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 8.5,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 1,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 23.5,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 31,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 38.5,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 46,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 53.5,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 53.5,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 46,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 46,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 46,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 53.5,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 46,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 31,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 31,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 8.5,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 1,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 16,
    width: 7.5,
    height: 7.5,
    rx: 3.75,
    fill: "black",
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrDots);
export default __webpack_public_path__ + "static/media/qr-dots.8079f0520c7e8fc6ca253d3c4f7fc9d2.svg";
export { ForwardRef as ReactComponent };